module.exports = __webpack_public_path__ + "img/slphouse_main4.f0df6168.png";